import { useDispatch, useSelector } from 'react-redux'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useSnackbar } from 'baseui/snackbar'
import { selectClientConfig } from '../SubscriptionFormSelectors'
import { useTranslation } from 'react-i18next'

const useClient = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const saveCustomer = () => {
    dispatch({
      type: subscriptionFormActionsV2.CUSTOMER_MODULE_SAVE_V2,
      enqueue,
    })
  }
  const { isSaving } = useSelector(selectClientConfig)

  return { saveCustomer, isSaving, t }
}

export default useClient
